import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Operadora, RecargasService, TipoOperador } from 'src/app/services/recargas/recargas.service';

@Component({
  selector: 'app-tipos-operacion',
  templateUrl: './tipos-operacion.component.html',
  styleUrls: ['./tipos-operacion.component.css']
})
export class TiposOperacionComponent implements OnInit {

  operadoraCode: string = '';
  operadora: Operadora | null = null;
  tiposOperacion: TipoOperador[] = [];
  loading: boolean = true;
  error: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private recargasService: RecargasService
  ) { }

  ngOnInit(): void {
    // Obtener el código de la operadora desde la ruta
    this.operadoraCode = this.route.snapshot.params['code'];
    
    // Obtener la operadora desde el state del router
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state?.['operadora']) {
      this.operadora = navigation.extras.state['operadora'];
    }
    
    // Cargar los tipos de operación
    this.loadTiposOperacion();
  }

  /**
   * Carga los tipos de operación para la operadora seleccionada
   */
  async loadTiposOperacion(): Promise<void> {
    try {
      this.loading = true;
      this.error = '';
      
      const response = await this.recargasService.getTypeOperators(this.operadoraCode);
      
      if (response?.resp) {
        // Filtra solo los tipos activos y visibles en consola
        this.tiposOperacion = this.recargasService.filterTypeOperatorsForConsole(response.resp);
      } else {
        this.tiposOperacion = [];
      }
      
    } catch (error) {
      console.error('Error loading tipos operacion:', error);
      this.error = 'Error al cargar los tipos de operación. Por favor, intente nuevamente.';
      this.tiposOperacion = [];
    } finally {
      this.loading = false;
    }
  }

  /**
   * Maneja la selección de un tipo de operación
   */
  onSelectTipoOperacion(tipo: TipoOperador): void {
    console.log('Tipo de operación seleccionado:', tipo);
    this.router.navigate(['/console/recargas/productos', this.operadoraCode, tipo.code], {
      state: { operadora: this.operadora, tipoOperador: tipo }
    });
  }

  /**
   * Recarga la lista de tipos de operación
   */
  onRetry(): void {
    this.loadTiposOperacion();
  }

  /**
   * Maneja errores de carga de imagen
   */
  onImageError(event: any): void {
    // Usa una imagen por defecto en caso de error
    event.target.src = '/assets/brandLogos/default.svg';
  }

  /**
   * Vuelve a la lista de operadoras
   */
  onVolver(): void {
    this.router.navigate(['/console/recargas/operadoras']);
  }

  /**
   * TrackBy function para optimizar el rendering del ngFor
   */
  trackByCode(index: number, tipo: TipoOperador): string {
    return tipo.code;
  }
} 